<template>
  <div class="mail-signature col-md-6">
    <div class="row">
      <div class="col-md-10 no-gutters">
        <div class="author-name mb-5">
          <strong>{{ authorName }}</strong>
        </div>
        <div>{{ authorTitle }} {{ companyName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MailSignature",

  props: {
    question: {
      type: Object,
      required: true
    }
  },

  computed: {
    companyName() {
      let qAuthorCompanyName = this.question.authorCompanyName,
        retVal = null;

      if (qAuthorCompanyName && qAuthorCompanyName !== "") {
        retVal = qAuthorCompanyName;
      } else if(this.role) {
        retVal = this.role.companyName;
      }
      
      return (retVal === " " || retVal === null) ? "" : ("| "+retVal);
    },
    authorTitle() {
      return this.question.authorTitle;
    },
    authorName() {
      return this.question.authorNameTagKey;
    },
    role() {
      return this.$store.state.role;
    }
  }
};
</script>
<style lang="scss" scoped>
.mail-signature {
  .row {
    padding-left: 20px;

    .col-md-10 {
      border-top: 2px solid #7eb4d6;
      
      .author-name {
        font-size: 1.7rem;
      }
    }
  }
}
</style>